"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const NativeSelect_1 = __importDefault(require("../../common/js/atoms/NativeSelect"));
const LoadingSpinner_1 = __importDefault(require("../../common/js/components/LoadingSpinner"));
const UserProfileAddress_1 = __importDefault(require("../atoms/UserProfileAddress"));
const SelectAddress = ({ address, options, onChange, placeholder, subhead, disabled, }) => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: "znd-shop-select-address" },
        react_1.default.createElement("div", { className: "znd-shop-select-address__subhead t-subhead-1" }, subhead),
        react_1.default.createElement(NativeSelect_1.default, { placeholder: placeholder, value: address?.id || '', options: options, disabled: disabled ?? false, alwaysShowPlaceholder: true, onChange: (key) => {
                setLoading(true);
                onChange(key).finally(() => {
                    setLoading(false);
                });
            } }),
        loading || !address ? (react_1.default.createElement("div", { className: "znd-shop-select-address__loading" },
            react_1.default.createElement(LoadingSpinner_1.default, { className: "ml-auto mr-auto" }))) : (react_1.default.createElement(UserProfileAddress_1.default, { className: " znd-shop-select-address__details", address: address, showOnlyAddress: true }))));
};
exports.default = (0, mobx_react_1.observer)(SelectAddress);
